<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editJobDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <DialogTitle
                    :close="closeEditItem"
                    :dialog-name="dialogName"
                />
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editNameErrors"
                                    @blur="$v.editName.$touch()"
                                    @input="$v.editName.$touch()"
                                    counter
                                    label="Name"
                                    maxlength="90"
                                    v-model="editName"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <DialogActions
                    :close="closeEditItem"
                    :save="saveEditItemAndCloseDialog"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from './../../ManagePersonnel/components/editTableFunctions';
    import {required,} from 'vuelidate/lib/validators'
    import {LOAD_JOB_TO_EDIT, RESET_DEFAULT_JOB_TO_EDIT, TOGGLE_EDIT_JOB_DIALOG, UPDATE_JOB_FIELD} from "@/store/job/mutations";
    import {SAVE_EDITED_JOB} from "@/store/job/actions.js";
    import {FETCH_JOB_LIST} from "../../../store/job/actions";
    import DialogTitle from "../../../components/DialogTitle";
    import DialogActions from "../../../components/DialogActions";

    export default {
        name: "EditJobDialog",

        validations: {
            editName: {required},
        },

        components: {
            DialogActions,
            DialogTitle
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                // Required for editTableFunctions
                idName: 'feedbackId',
                dialogName: 'Edit Job',
                startDateMenu: false,
                endDateMenu: false,
            }
        },
        computed: {
            editJobDialog: {
                get() {
                    return this.$store.state.job.editJobDialog;
                },
            },
            editName: {
                get() {
                    return this.$store.state.job.editJob.name;
                },
                set(value) {
                    this.updateEditedValue('name', value);
                },
            },
            editNameErrors() {
                const errors = [];
                if (!this.$v.editName.$dirty) return errors;
                !this.$v.editName.required && errors.push('required.');
                return errors
            },
            ...mapGetters(
            [
                "liveJobList",
                "employmentTypeList",
                "ecsCompanyList",
            ]
            ),
            ...mapGetters({
                id: "editJobId"
            })
        },

        methods: {
            async validateAll() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                let areValid = false;

                if (formState == 'complete') {
                    areValid = true;
                }

                return areValid;
            },

            ...mapActions({
                fetchItem: FETCH_JOB_LIST,
                updateTableItemRecord: SAVE_EDITED_JOB,
                // saveNewTableItemRecord: '',
                // deleteTableItem: '',
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_JOB_DIALOG,
                loadTableItemToEdit: LOAD_JOB_TO_EDIT,
                updateTableItemToEdit: UPDATE_JOB_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_JOB_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
